/**
 * Stories implemented by ZillowNavbar
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent } from 'react';
import { TestID } from 'src/common/TestID';
import { HeaderLinksConfiguration } from '../../page-frame-types/HeaderLinksConfiguration';
import { HEADER_VERSIONS, ZILLOW_NAVBAR_STATIC_TEST_IDS } from '../../constants';
import { MobileDropdownMenuContainer } from './components/MobileDropdownMenuContainer';
import { MobileDropdownMenuContentContainer } from './components/MobileDropdownMenuContentContainer';
import { ZillowNavbarMobileDropdownMenuSections } from './components/MobileDropdownMenuSections';

export type ZillowNavbarMobileDropdownMenuProps = {
    links: HeaderLinksConfiguration;
    zhlHost: string;
    isOpen: boolean;
    version: HEADER_VERSIONS;
};

export const ZillowNavbarMobileDropdownMenu: FunctionComponent<ZillowNavbarMobileDropdownMenuProps> = ({
    links,
    isOpen,
    zhlHost,
    version,
}) => {
    const { main, agent, marketing, help } = links;
    if (!isOpen) {
        return null;
    }
    const testID = new TestID(ZILLOW_NAVBAR_STATIC_TEST_IDS.MOBILE_DROPDOWN);
    return (
        <MobileDropdownMenuContainer {...testID.getCypressTestIDAttribute()}>
            <MobileDropdownMenuContentContainer>
                <ZillowNavbarMobileDropdownMenuSections version={version} zhlHost={zhlHost} links={main} />
                <ZillowNavbarMobileDropdownMenuSections version={version} zhlHost={zhlHost} links={agent} />
                <ZillowNavbarMobileDropdownMenuSections version={version} zhlHost={zhlHost} links={marketing} />
                <ZillowNavbarMobileDropdownMenuSections version={version} zhlHost={zhlHost} links={help} />
            </MobileDropdownMenuContentContainer>
        </MobileDropdownMenuContainer>
    );
};
